import { ViewTypes } from 'components/spreadsheet/constants/const'
import { ISpreadsheetData } from 'components/spreadsheet/types'
import { ICustomViewVersion } from 'types'

/** A Custom View's newest version when its owners haven't published it, or null: the banner over the page publishes
 * or discards it. */
export const getUnpublishedVersion = (spreadsheetData: ISpreadsheetData): ICustomViewVersion | null =>
  spreadsheetData.viewDetails.type === ViewTypes.CUSTOM_VIEW
    ? (spreadsheetData.viewDetails.customViewLatest ?? null)
    : null

export const hasUnpublishedVersion = (spreadsheetData: ISpreadsheetData): boolean =>
  getUnpublishedVersion(spreadsheetData) !== null

/** What the save icon saves: the view's own changes (filters, sorts, hidden columns). A Custom View's unpublished
 * version isn't one of them: it's published from the banner over the page. */
export const hasUnsavedChanges = (spreadsheetData: ISpreadsheetData): boolean =>
  spreadsheetData.userConfiguration.unsavedChanges
